<template>
  <div>
    <b-alert
      v-if="items.length === 0"
      show
      variant="secondary"
      class="text-center"
    >
      Nenhum produto vendido neste período
    </b-alert>

    <template v-else>
      <h4 class="d-flex justify-content-between mb-3">
        <b>Total Valor: {{ totalAmount | formatCurrency }}</b>
        <b>Total Vendas: {{ totalSales }}</b>
      </h4>

      <b-table :fields="fields" :items="items" striped hover responsive>
        <template #cell(productName)="{ item }">
          <span>{{ item.productName }}</span>
        </template>

        <template #cell(sales)="{ item }">
          <span>{{ item.sales }}</span>
        </template>

        <template #cell(amount)="{ item }">
          <span>{{ item.amount | formatCurrency }}</span>
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
import { reduce } from 'lodash/fp'
import { formatCurrency } from '@/helpers/numbers'

export default {
  name: 'SalesPerProductReportList',
  filters: {
    formatCurrency
  },
  props: {
    payments: {
      type: Object,
      required: true
    }
  },
  computed: {
    items() {
      return Array.isArray(this.payments.data) ? this.payments.data : []
    },
    fields() {
      return [
        { key: 'productName', label: 'Produto' },
        { key: 'sales', label: 'Quantidade Vendida' },
        { key: 'amount', label: 'Total Venda' }
      ]
    },
    totalAmount() {
      return reduce((sum, item) => sum + (item.amount || 0), 0, this.items)
    },
    totalSales() {
      return reduce((sum, item) => sum + (item.sales || 0), 0, this.items)
    }
  }
}
</script>
